import { InfoIcon } from "@moznsystems/mozn-ui";
import type { ComponentProps, FC, ReactNode } from "react";
import { TextTooltip } from "../text-tooltip";

type InfoTooltipProps = {
	content: ReactNode;
	/** Accessible name for the icon button, e.g. "About time-framed values". */
	ariaLabel: string;
	placement?: ComponentProps<typeof TextTooltip>["placement"];
};

/** Info icon that reveals `content` on hover or keyboard focus. */
const InfoTooltip: FC<InfoTooltipProps> = ({
	content,
	ariaLabel,
	placement = "top",
}) => (
	<TextTooltip content={content} placement={placement}>
		<button
			type="button"
			aria-label={ariaLabel}
			className="inline-flex cursor-help border-0 bg-transparent p-0"
		>
			<InfoIcon color="var(--c-gray-3)" width={15} height={15} />
		</button>
	</TextTooltip>
);

export { InfoTooltip };
